import {PinProtect} from '~/features/Auth/PinProtect';

import {PremiumStats} from '~/features/Premium';

export const PremiumStatsScreen = () => {
  return (
    <div className="bg-background min-h-screen">
      <PinProtect>
        <PremiumStats />
      </PinProtect>
    </div>
  );
};
